<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div
      id="kt_app_content_container"
      class="app-container container-fluid user-list-page-container"
    >
      <div>
        <div class="d-flex justify-content-between align-items-center mb-4">
          <div class="d-flex flex-column">
            <h3 class="card-label fw-bold fs-3 mb-1">
              {{
                userConfig?.pageTitleKey
                  ? (userConfig.pageTitleKey | translate)
                  : ("userList" | translate)
              }}
            </h3>
          </div>

          <div
            [hidden]="userListLoading || userCards.length === 0"
            class="d-flex align-items-center gap-3"
          >
            <button
              class="btn btn-icon btn-active-light-primary cursor-pointer"
              (mouseenter)="showTooltip($event, 'filter')"
              (mouseleave)="hideTooltip()"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseExample"
              aria-expanded="false"
              aria-controls="collapseExample"
            >
              <i class="fa-solid fa-filter"></i>
            </button>

            <!-- Custom tooltip element -->
            <div
              class="risk-tooltip"
              *ngIf="activeTooltip"
              [style.left.px]="activeTooltip.x"
              [style.top.px]="activeTooltip.y"
            >
              {{ activeTooltip.text }}
            </div>

            <div class="d-flex align-items-center gap-3">
              <button
                *appHasClaim="'create_user_claim'"
                type="button"
                class="btn btn-sm fw-bold btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#createUserModal"
                (click)="openCreateUserModal($event)"
              >
                {{ "createNewUser" | translate }}
              </button>
            </div>
          </div>
        </div>
        <div>
          <div class="collapse mb-8" id="collapseExample">
            <form (submit)="filterUserList($event)">
              <div class="row align-items-end">
                <div class="col-xl-2 col-lg-4 mt-xl-0 mt-4 col-sm-6">
                  <label class="form-label fs-14">
                    {{ "nameSurname" | translate }}
                  </label>
                  <input
                    [(ngModel)]="filterForm.nameSurname"
                    type="text"
                    class="form-control fs-14"
                    name="nameSurname"
                    [placeholder]="'filterByNameAndSurname' | translate"
                  />
                </div>

                <div class="col-xl-2 col-lg-4 mt-xl-0 mt-4 col-sm-6">
                  <label class="form-label fs-14">
                    {{ "role" | translate }}
                  </label>
                  <div class="dropdown">
                    <button
                      class="form-select fs-14 text-start w-100"
                      type="button"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="outside"
                      aria-expanded="false"
                    >
                      <span class="text-truncate d-block">{{
                        getRoleDisplayText()
                      }}</span>
                    </button>
                    <div
                      class="dropdown-menu w-100 shadow-lg max-h-300 overflow-auto"
                    >
                      <div
                        *ngFor="let role of roles"
                        class="dropdown-item cursor-pointer d-flex align-items-center py-2 px-3"
                        (click)="
                          toggleRoleSelection(role.id); $event.stopPropagation()
                        "
                        [class.active-selection]="isRoleSelected(role.id)"
                      >
                        <div class="d-flex align-items-center">
                          <div
                            style="width: 20px"
                            class="d-flex justify-content-center me-2"
                          >
                            <i
                              *ngIf="isRoleSelected(role.id)"
                              class="fa-solid fa-check fs-12"
                            ></i>
                          </div>
                          <span class="fs-14">{{ role.name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="col-xl-2 col-lg-4 mt-xl-0 mt-4 col-sm-6"
                  *ngIf="isSystemAdmin"
                >
                  <label class="form-label fs-14">
                    {{ "organization.organization" | translate }}
                  </label>
                  <div class="dropdown">
                    <button
                      class="form-select fs-14 text-start w-100"
                      type="button"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="outside"
                      aria-expanded="false"
                    >
                      <span class="text-truncate d-block">{{
                        getOrganizationDisplayText()
                      }}</span>
                    </button>
                    <div
                      class="dropdown-menu w-100 shadow-lg max-h-300 overflow-auto"
                    >
                      <div
                        *ngFor="let org of organizations"
                        class="dropdown-item cursor-pointer d-flex align-items-center py-2 px-3"
                        (click)="
                          toggleOrganizationSelection(org.id);
                          $event.stopPropagation()
                        "
                        [class.active-selection]="
                          isOrganizationSelected(org.id)
                        "
                      >
                        <div class="d-flex align-items-center">
                          <div
                            style="width: 20px"
                            class="d-flex justify-content-center me-2"
                          >
                            <i
                              *ngIf="isOrganizationSelected(org.id)"
                              class="fa-solid fa-check fs-12"
                            ></i>
                          </div>
                          <span class="fs-14">{{ org.name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="col-xl-2 col-lg-4 mt-xl-0 mt-4 col-sm-6"
                  *ngIf="filterForm.organizationId.length > 0"
                >
                  <label class="form-label fs-14">
                    {{ "facility" | translate }}
                  </label>
                  <div class="dropdown">
                    <button
                      class="form-select fs-14 text-start w-100"
                      type="button"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="outside"
                      aria-expanded="false"
                    >
                      <span class="text-truncate d-block">{{
                        getFacilityDisplayText()
                      }}</span>
                    </button>
                    <div
                      class="dropdown-menu w-100 shadow-lg max-h-300 overflow-auto"
                    >
                      <div
                        *ngFor="let facility of facilities"
                        class="dropdown-item cursor-pointer d-flex align-items-center py-2 px-3"
                        (click)="
                          toggleFacilitySelection(facility.id);
                          $event.stopPropagation()
                        "
                        [class.active-selection]="
                          isFacilitySelected(facility.id)
                        "
                      >
                        <div class="d-flex align-items-center">
                          <div
                            style="width: 20px"
                            class="d-flex justify-content-center me-2"
                          >
                            <i
                              *ngIf="isFacilitySelected(facility.id)"
                              class="fa-solid fa-check fs-12"
                            ></i>
                          </div>
                          <span class="fs-14">{{ facility.name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-xl-2 col-lg-4 mt-xl-0 mt-4 col-sm-6">
                  <label class="form-label fs-14">
                    {{ "email" | translate }}
                  </label>
                  <input
                    [(ngModel)]="filterForm.email"
                    type="email"
                    class="form-control fs-14"
                    name="email"
                    [placeholder]="'filterByEmail' | translate"
                  />
                </div>

                <div class="ms-auto col-xl-2 col-lg-4 mt-xl-0 mt-4 col-sm-6">
                  <div class="d-flex justify-content-end gap-4">
                    <button
                      type="button"
                      class="btn btn-secondary cursor-pointer fs-14"
                      (click)="clearFilters()"
                    >
                      {{ "clear" | translate }}
                    </button>

                    <button
                      type="submit"
                      class="btn btn-primary cursor-pointer fs-14"
                    >
                      {{ "filter" | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div>
          <div
            *ngIf="userListLoading"
            class="d-flex justify-content-center pb-4"
          >
            <div class="spinner-border text-danger" role="status">
              <span class="visually-hidden">
                {{ "loading" | translate }}...
              </span>
            </div>
          </div>

          <div
            *ngIf="!userListLoading && userCards.length === 0"
            class="py-5 text-center fs-5"
          >
            {{ "noUsersAvailableToBeDisplayedHere" | translate }}
          </div>

          <div
            class="grid-header"
            *ngIf="
              (userConfig?.columns?.length || 0) > 0 &&
              !userListLoading &&
              userCards.length > 0
            "
          >
            <ng-container *ngFor="let col of userConfig?.columns || []">
              <div
                [ngClass]="getColClass(col)"
                (click)="
                  col.key === 'name' ||
                  col.key === 'userOrganizations' ||
                  col.key === 'userStatus'
                    ? onSort(col.key)
                    : null
                "
                [class.cursor-pointer]="
                  col.key === 'name' ||
                  col.key === 'userOrganizations' ||
                  col.key === 'userStatus'
                "
              >
                {{ col.labelKey | translate }}
                <ng-container
                  *ngIf="
                    (filterForm.sortBy === 'name' && col.key === 'name') ||
                    (filterForm.sortBy === 'userOrganizations' &&
                      col.key === 'userOrganizations') ||
                    (filterForm.sortBy === 'userStatus' &&
                      col.key === 'userStatus')
                  "
                >
                  <i
                    class="fa-solid ms-1"
                    style="font-size: 0.65em !important; vertical-align: middle"
                    [ngClass]="{
                      'fa-chevron-down': filterForm.sortDirection === 'desc',
                      'fa-chevron-up': filterForm.sortDirection === 'asc',
                    }"
                  ></i>
                </ng-container>
              </div>
            </ng-container>
          </div>

          <ng-container *ngIf="!userListLoading && users.length > 0">
            <app-dynamic-list
              *ngFor="let user of users"
              [item]="user"
              [columns]="userConfig.columns"
              [actions]="userConfig.actions"
              [disableScrollableItems]="true"
              (click)="onCardClick(user)"
            >
            </app-dynamic-list>
          </ng-container>
        </div>

        <ng-container *ngIf="!userListLoading && userCards.length > 0">
          <div class="d-flex flex-stack flex-wrap pt-10">
            <div class="d-flex align-items-center gap-6">
              <div class="flex align-items-center gap-2">
                <label class="me-2 fs-6 fw-semibold text-gray-700">
                  {{ "pageSize" | translate }}:
                </label>
                <app-page-size-selector
                  [sizes]="pageSizes"
                  [selectedSize]="pageSize"
                  (sizeChange)="changePageSize($event)"
                >
                </app-page-size-selector>
              </div>
              <div class="fs-6 fw-semibold text-gray-700">
                {{ "showing" | translate }} {{ userCards.length }}
                {{ "of" | translate }} {{ totalUser }}
                {{ "users" | translate }}
              </div>
            </div>

            <ul class="pagination">
              <li
                class="page-item previous cursor-pointer"
                [class.disabled]="currentPage === 1"
              >
                <a class="page-link" (click)="previousPage(currentPage)">
                  <i class="previous"></i>
                </a>
              </li>

              <li
                *ngFor="let page of [].constructor(totalPage); let i = index"
                class="page-item cursor-pointer"
                [class.active]="currentPage === i + 1"
              >
                <a class="page-link" (click)="changePage(i)">
                  {{ i + 1 }}
                </a>
              </li>

              <li
                class="page-item next cursor-pointer"
                [class.disabled]="currentPage === totalPage"
              >
                <a class="page-link" (click)="nextPage(currentPage + 1)">
                  <i class="next"></i>
                </a>
              </li>
            </ul>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- Delete User Modal -->
<div
  class="modal fade"
  [id]="'exampleModal-' + deleteModalId"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-2" id="exampleModalLabel">
          {{ "deleteUser" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close cursor-pointer"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body fs-4">
        {{
          "thisActionCannotBeUndoneAreYouSureYouWantToDeleteThisUser"
            | translate
        }}
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary cursor-pointer"
          data-bs-dismiss="modal"
        >
          {{ "cancel" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary cursor-pointer"
          (click)="deleteUser(deleteModalId)"
          data-bs-dismiss="modal"
        >
          {{ "delete" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
